var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenudotsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1.18421C6 1.83923 6.59975 2.36842 7.34211 2.36842C8.08446 2.36842 8.68421 1.83923 8.68421 1.18421C8.68421 0.529194 8.08446 0 7.34211 0C6.59975 0 6 0.529194 6 1.18421ZM7.34211 4.44079C8.08446 4.44079 8.68421 4.96998 8.68421 5.625C8.68421 6.28002 8.08446 6.80921 7.34211 6.80921C6.59975 6.80921 6 6.28002 6 5.625C6 4.96998 6.59975 4.44079 7.34211 4.44079ZM7.34211 11.25C6.59975 11.25 6 10.7208 6 10.0658C6 9.41077 6.59975 8.88158 7.34211 8.88158C8.08446 8.88158 8.68421 9.41077 8.68421 10.0658C8.68421 10.7208 8.08446 11.25 7.34211 11.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenudotsIcon);
export default __webpack_public_path__ + "static/media/menudots_icon.c1591f81968828d4268b5abc53154a61.svg";
export { ForwardRef as ReactComponent };